import * as Sentry from '@sentry/react';

interface CrashContext {
  componentStack?: string | null;
}

const normalizeError = (error: unknown): Error => {
  if (error instanceof Error) return error;

  return new Error(typeof error === 'string' ? error : 'A non-Error value caused the carousel to crash');
};

export const reportCrash = (error: unknown, context: CrashContext = {}): string => {
  const normalizedError = normalizeError(error);

  return Sentry.captureException(normalizedError, {
    level: 'fatal',
    tags: {
      errorType: 'crash',
      source: 'react-error-boundary',
    },
    contexts: context.componentStack
      ? {
          react: {
            componentStack: context.componentStack,
          },
        }
      : undefined,
  });
};
